<header>
  <nav aria-label="Site Navigation">
    <mat-toolbar class="header">
      <mat-toolbar-row>
        <a routerLink="/main">
          <img [src]="appLogo" class="header-image" alt="logo" aria-label="Application logo" />
        </a>
        <span class="toolbar-spacer"></span>
        <div>
          @if(numUnreadMessages > 0){
          <button matButton class="header-toolbar-button" [matMenuTriggerFor]="notificationsMenu" aria-label="Notifications menu">
            <mat-icon [matBadge]="numUnreadMessages" aria-hidden="false">notifications</mat-icon>
            {{'header.messages' | translate}}
          </button>

          }
          @else{
          <button matButton class="header-toolbar-button" [matMenuTriggerFor]="notificationsMenu" aria-label="Notifications menu">
            <mat-icon>notifications</mat-icon>{{'header.messages' | translate}}
          </button>
          }

          <mat-menu #notificationsMenu="matMenu">
            @if(numUnreadMessages > 0){
            <button mat-menu-item>
              <mat-icon [matBadge]="numUnreadMessages" aria-hidden="false">forum</mat-icon>
              <span>{{'header.all-messages' | translate}}</span>
            </button>
            }@else{
            <button mat-menu-item>
              <mat-icon>forum</mat-icon>
              <span>{{'header.all-messages' | translate}}</span>
            </button>
            }
            <button mat-menu-item>
              <mat-icon>chat_add_on</mat-icon>
              <span>{{'header.new-message' | translate}}</span>
            </button>
          </mat-menu>
          <button matButton class="header-toolbar-button" [matMenuTriggerFor]="userMenu" aria-label="User menu">
            <mat-icon>person</mat-icon>{{user?.userName}}
          </button>
          <mat-menu #userMenu="matMenu">
            <button mat-menu-item disabled>
              <mat-icon>account_circle</mat-icon>
              <span>{{user?.dropDownLabel}}</span>
            </button>
            <button mat-menu-item>
              <mat-icon>manage_accounts</mat-icon>
              <span>{{'header.edit-profile' | translate}}</span>
            </button>
            <button mat-menu-item (click)="signOut()">
              <mat-icon>logout</mat-icon>
              <span>{{'header.logout' | translate}}</span>
            </button>
          </mat-menu>
          <button matButton class="header-toolbar-button" [matMenuTriggerFor]="languageMenu" aria-label="Language menu">
            <mat-icon [matBadge]="defaultLang" aria-hidden="false">language</mat-icon>{{'header.language' | translate}}
          </button>
          <mat-menu #languageMenu="matMenu">
            @for (lang of availableLangs; track lang) {
            @if(lang.value == defaultLang){
            <button mat-menu-item (click)="translateApp(lang)" class="button-icon-right">
              <mat-icon>check_small</mat-icon>
              <b>{{lang.label}}</b>
            </button>
            }
            @else{
            <button mat-menu-item (click)="translateApp(lang)">
              <span>{{lang.label}}</span>
            </button>
            }
            }
          </mat-menu>
        </div>
        

      </mat-toolbar-row>
      @if(menu && menu.items){
      <mat-toolbar-row>
        @for( item of menu.items; track item.label ){
        <ng-container>
          @if(item.childItems){
          <button matButton [matMenuTriggerFor]="menu" class="button-icon-right">
            <span>{{getMenuItemLabel(item)}}</span>
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            @for( subItem of item.childItems; track subItem.label ){
            <a mat-menu-item [routerLink]="subItem.url.toLowerCase()" title="{{ getMenuItemLabel(subItem) }}">
              <span>{{getMenuItemLabel(subItem)}}</span>
            </a>
            }
          </mat-menu>
          }
          @else {
          <button matButton>
            <span>{{getMenuItemLabel(item)}}</span>
          </button>
          }
        </ng-container>
        }

        <span class="toolbar-spacer"></span>
        <span></span>
        <span class="toolbar-spacer"></span>
        <button matButton>
          <mat-icon>event</mat-icon>
          <span>{{'header.calendar' | translate}}</span>
        </button>
        <a matButton href="https://www.google.com/" target="_blank" aria-label="Open Help Center">
          <mat-icon>open_in_new</mat-icon> {{'header.help-center' | translate}}
        </a>
      </mat-toolbar-row>
      }
    </mat-toolbar>
  </nav>
</header>

